<template>
    <div data-test-id="cnt-auth">
        <v-ons-list class="section-h">

            <div>
                <gtc-button v-if="social_only == false" class="btn-action branded" v-on:click="showSignup(true)"
                            data-test-id="btn-signup">
                    Create account
                </gtc-button>
            </div>

            <div class="mt-16">
                <gtc-button v-if="social_only == false" class="btn-action branded" v-on:click="showLogin(true)"
                            data-test-id="btn-login">
                    Login with account
                </gtc-button>
            </div>

            <div class="mt-16" v-if="show_login_google || show_login_facebook">
                <div class="main-text text-centre mb-20">You can also {{ action ? action : 'login' }} with </div>
                <div class="gtc-round-button-container mb-20">
                    <gtc-button v-on:click="fbLogin" v-show="show_login_facebook" icon="icon-facebook" class="secondary round"/>
                    <gtc-button v-on:click="googleLogin" v-show="show_login_google" icon="icon-google" class="secondary round"/>
                </div>
            </div>

            <div class="mt-16" v-if="social_only == false && allow_guest_checkout">
                <gtc-button modifier="large" class="btn-action branded" v-on:click="showGuestCheckout(true)"
                            data-test-id="btn-guest">
                    Guest checkout
                </gtc-button>
            </div>

        </v-ons-list>

        <v-ons-alert-dialog
            title="Login" v-bind:visible="show_login_dlg" data-test-id="cnt-form-login">
            <v-ons-list class="section-h">
                <form @submit.prevent="login">
                    <v-ons-list-item>
                        <div class="center">
                            <v-ons-input placeholder="Email" float v-model="form.login.email" type="email"
                                         data-test-id="inp-email"/>
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item>
                        <div class="center">
                            <v-ons-input placeholder="Password" float v-model="form.login.password" type="password"
                                         minlength="6" data-test-id="inp-password"/>
                        </div>
                    </v-ons-list-item>
                    <section class="section-vh">
                        <gtc-button modifier="large" v-on:click="login"
                                    v-bind:disabled="!can_login || logging_in" v-bind:in_progress="logging_in"
                                    class="btn-action branded" data-test-id="btn-action-login">
                            Login
                        </gtc-button>
                    </section>
                    <section class="section-vh">
                        <gtc-button modifier="large" v-on:click="forgot" class="btn-action branded"
                                    data-test-id="btn-action-forgot-password">
                            Forgot password
                        </gtc-button>
                    </section>
                    <section class="section-vh">
                        <gtc-button modifier="large" v-on:click="showLogin(false)" class="secondary"
                                    data-test-id="btn-action-cancel">
                            Cancel
                        </gtc-button>
                    </section>
                    <!-- Fake submit button required to allow submit on enter behaviour. Not possible to add 'submit'
                         attribute to existing v-ons-button in the form -->
                    <input type="submit" style="position: absolute; left: -9999px"/>
                </form>
            </v-ons-list>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
            title="Signup" v-bind:visible="show_signup_dlg" data-test-id="cnt-form-signup">
            <v-ons-list class="section-h">
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Name" name="name" float v-model="form.signup.name"
                                     data-test-id="inp-name"/>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Email" name="email" float v-model="form.signup.email" type="email"
                                     data-test-id="inp-email"/>
                        <span v-show="signup_email_valid == false" class="warning-text">Please enter a valid email address.</span>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Phone" name="phone" float v-model="form.signup.phone" type="tel"
                                     minlength="10" data-test-id="inp-phone"/>
                        <span v-show="signup_phone_valid == false" class="warning-text">The phone number must only contain numbers and be at least 10 digits.</span>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Password" name="password" float v-model="form.signup.password"
                                     type="password" minlength="6" data-test-id="inp-password"/>
                        <span v-show="signup_password_valid == false" class="warning-text">The password must be at least 6 characters.</span>
                    </div>
                </v-ons-list-item>
                <section class="section-vh">
                    <gtc-button modifier="large" v-on:click="signup" v-bind:disabled="!can_signup"
                                v-bind:in_progress="signup_loading" class="btn-action branded" data-test-id="btn-action-signup">
                        Signup
                    </gtc-button>
                </section>
                <section class="section-vh">
                    <gtc-button modifier="large" v-on:click="showSignup(false)" class="secondary" data-test-id="btn-action-cancel">
                        Cancel
                    </gtc-button>
                </section>
            </v-ons-list>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
            title="Guest checkout" v-bind:visible="show_guest_checkout_dlg" data-test-id="cnt-form-guest">
            <v-ons-list class="section-h">
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Name" name="name" float v-model="form.guest_checkout.name"
                                     data-test-id="inp-name"/>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Email" name="email" float v-model="form.guest_checkout.email"
                                     type="email" data-test-id="inp-email"/>
                        <span v-show="guest_email_valid == false" class="warning-text">Please enter a valid email address.</span>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item>
                    <div class="center">
                        <v-ons-input placeholder="Phone" name="phone" float v-model="form.guest_checkout.phone" type="tel"
                                     minlength="10" data-test-id="inp-phone"/>
                        <span v-show="guest_phone_valid == false" class="warning-text">The phone number must only contain numbers and be at least 10 digits.</span>
                    </div>
                </v-ons-list-item>
                <section class="section-vh">
                    <gtc-button modifier="large" v-on:click="guestCheckout" v-bind:disabled="!can_guest_checkout"
                                class="btn-action branded" data-test-id="btn-action-continue">
                        Continue
                    </gtc-button>
                </section>
                <section class="section-vh">
                    <gtc-button modifier="large" v-on:click="showGuestCheckout(false)" class="secondary"
                                data-test-id="btn-action-cancel">
                        Cancel
                    </gtc-button>
                </section>
            </v-ons-list>
        </v-ons-alert-dialog>

        <validation v-bind:show="validation.show"
                    v-bind:errors="validation.errors"
                    v-on:show="(show) => validation.show = show"></validation>
    </div>

</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as ValidationComponent } from '../fragments/validation'
    import { default as ForgotPasswordMixin } from '../../mixins/forgot_password'

    export default {

        name: 'social-login',

        props: ['redirect', 'signup_save', 'login_redirect', 'allow_guest_checkout', 'social_only', 'action'],

        mixins: [ForgotPasswordMixin],

        components: {
            'validation': ValidationComponent,
        },

        created () {

        },

        mounted() {

        },

        data () {
            return {
                app: this.$root.$data.app,
                show_login_dlg: false,
                show_signup_dlg: false,
                show_guest_checkout_dlg: false,
                form: {
                    login: {
                        email: '',
                        password: '',
                    },
                    signup: {
                        name: '',
                        email: '',
                        phone: '',
                        password: '',
                    },
                    guest_checkout: {
                        name: '',
                        email: '',
                        phone: '',
                    }
                },
                validation: {
                    show: false,
                    errors: null,
                },
                logging_in: false,
                signup_loading: false,
            }
        },

        watch: {

        },

        computed: {

            ...mapGetters([
                'app_embed'
            ]),

            show_login_google: function(){
                return (!!(window.env.google_client_key)) && !this.app_embed
            }, 

            show_login_facebook: function(){
                return (!!(window.env.facebook_app_id)) && !this.app_embed
            },

            can_login: function(){
                return this.form.login.email.length > 0 && this.form.login.password.length > 0
            },

            can_signup: function(){
                const fields = ['name', 'email', 'phone', 'password']
                return fields.every(f => this.form.signup[f] && this.form.signup[f].length > 0) &&
                    this.signup_email_valid &&
                    this.signup_phone_valid &&
                    this.signup_password_valid
            },

            can_guest_checkout: function(){
                const fields = ['name', 'email', 'phone']
                return fields.every(f => this.form.guest_checkout[f] && this.form.guest_checkout[f].length > 0) &&
                    this.guest_email_valid &&
                    this.guest_phone_valid
            },

            guest_phone_valid: function(){
                return this.phoneValid(this.form.guest_checkout.phone)
            },

            guest_email_valid: function(){
                return this.emailValid(this.form.guest_checkout.email)
            },

            signup_phone_valid: function(){
                return this.phoneValid(this.form.signup.phone)
            },

            signup_email_valid: function(){
                return this.emailValid(this.form.signup.email)
            },

            signup_password_valid: function (){
                return this.passwordValid(this.form.signup.password)
            },
        },

        methods: {

            ...mapMutations([
                'setLoginRedirect',
            ]),

            showLogin(show = true){
                this.show_login_dlg = show
            },

            login(){
                this.logging_in = true
                this.app.http.post('/jwt/authenticate', this.form.login)
                    .then(response => {
                        this.logging_in = false
                        this.show_login_dlg = false
                        this.$store.commit('login', response.data)

                        if (this.redirect)
                            this.$router.push(this.app.homeRoute())
                    })
                    .catch(error => {
                        this.logging_in = false
                        if (error.response && error.response.data && error.response.data.errors) {
                            this.validation.errors = error.response.data.errors
                            this.validation.show = true
                        } else {
                            this.$ons.notification.alert(this.app.getResponseErrorMessage(error), {title: ''})
                        }
                    })
            },

            forgot(){
                this.show_login_dlg = false

                this.$ons.notification.prompt(
                        'Please enter the email address for your account',
                        {
                            title: 'Reset password',
                            inputType: 'email',
                            defaultValue: this.form.login.email,
                        }
                    )
                    .then(email => {

                        if (email.length == 0)
                            return

                        this.sendForgotPasswordResetEmail(email)
                    })
            },

            showSignup(show = true){

                this.show_signup_dlg = show
            },

            signup() {

                const data = Object.assign({}, this.form.signup)
                data.phone = this.filters.noSpace(data.phone)

                if (this.signup_save) {

                    const progress = () => {
                        this.$emit('userSignup', data)
                        this.show_signup_dlg = false
                    }

                    this.signup_loading = true

                    const title = 'Account signup'
                    this.app.http.post('user/signup/validate', data)
                        .then(response => {
                            this.signup_loading = false
                            if (response.data.exists) {
                                this.$ons.notification.alert(
                                    response.data.message,
                                    { title }
                                )
                            } else {
                                progress()
                            }
                        })
                        .catch(error => {
                            this.signup_loading = false

                            if (error.response && error.response.data && error.response.data.errors) {
                                this.validation.errors = error.response.data.errors
                                this.validation.show = true
                            } else {
                                this.$ons.notification.alert(
                                    this.app.getResponseErrorMessage(error),
                                    { title },
                                )
                            }
                        })

                    return
                }

                this.app.http.post('user/signup', this.form.signup)
                    .then(response => {
                        this.$ons.notification.alert(
                            response.data.message,
                            {title: 'Success'}
                        )
                        .then(() => this.$router.push(this.app.homeRoute()))

                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.errors) {
                            this.validation.errors = error.response.data.errors
                            this.validation.show = true
                        } else {
                            this.$ons.notification.alert(this.app.getResponseErrorMessage(error))
                        }
                    })
            },

            showGuestCheckout(show = true){

               this.show_guest_checkout_dlg = show
            },

            guestCheckout(){

                const data = Object.assign({}, this.form.guest_checkout)
                data.phone = this.filters.noSpace(data.phone)
                this.$emit('userGuestCheckout', data)

                this.show_guest_checkout_dlg = false
            },

            googleLogin(){

                if ('gapi' in window == false) {
                    this.handleSocialLoginUnavailable('Google')
                    return
                }

                gapi.load('auth2', () => {
                    gapi.auth2.authorize({
                        client_id: window.env.google_client_key,
                        prompt: 'select_account',
                        scope: 'email profile openid',
                        response_type: 'id_token permission',
                    }, (response) => {
                        if (response.error) {
                            if (response.error != 'popup_closed_by_user') {
                                this.app.logException(new Error('Google login failed.'), {
                                    response
                                })
                                this.$ons.notification.alert('There was an error logging in with Google. You may need to click the Google button a second time for the dialog to appear.')
                            }
                            return;
                        }

                        const token = response.id_token
                        this.handleSocialLogin('google', token)
                    })
                })

            },

            fbLogin(){

                if ('FB' in window == false){
                    this.handleSocialLoginUnavailable('Facebook')
                    return
                }

                FB.login(response => {
                    if (!response.authResponse){
                        this.app.logException(new Error('Facebook login failed.'), {
                            response
                        })
                        this.$ons.notification.alert('There was an error logging in with Facebook, please try again later.')
                        return;
                    }
                    const token = response.authResponse.accessToken;
                    this.handleSocialLogin('facebook', token)
                }, {
                    scope: 'email,public_profile',
                    return_scopes: true
                });
            },

            handleSocialLogin(provider, token){

                if (this.login_redirect)
                    this.setLoginRedirect(this.login_redirect)

                this.$router.push({
                    name: 'LoginSocial',
                    params: {
                        token,
                        provider,
                    }
                })
            },

            handleSocialLoginUnavailable(provider){
                this.$ons.notification.alert(
                    `Could not connect to ${provider}. This can be caused be caused by adblockers or a slow network connection.
                    Please whitelist this site in your adblocker if you are using one or login with an email address and password.`,
                    { title: `${provider} error` }
                )
            },

            emailValid(value) {
                return (value == null || value.length == 0) || (value.includes('@') && value.includes('.'))
            },

            phoneValid(value){
                return (value == null || value.length == 0) || (value.length >= 10 && /^[\d\s]+$/.test(value))
            },

            passwordValid(value){
                return (value == null || value.length == 0) || value.length >= 6
            },
        }
    }
</script>

<style scoped>
    .loading-spinner {
        height: 23px; 
        width: 23px; 
        position: fixed;
        top: 50%;
        transform: translate(40%, -50%);
    }
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/login.vue